import { UserDataContract } from 'models'

export type usernameLogin = (payload: {
    username: string
    password: string
}) => Promise<any>

export interface AuthResponse {
    token: string
    message: string
    isAuthenticated: boolean
    actionCodes: number[]
}

export interface ValidateTokenResult {
    user: UserDataContract
}

export enum AuthorizationState {
    /** When prepare for authorization */
    PREPARE,

    /** When processing authorization */
    PROCESSING,

    /** success authorization in real token level */
    SUCCESS_REAL_CLIENT,

    /** success authorization but in Non-Client token level */
    SUCCESS_NON_CLIENT,

    /** authentication error */
    ERROR_AUTH,

    /** When token is expired */
    EXPIRED,
}

export interface AuthState {
    isAuthExpired: boolean
    isLoggedOut: boolean
    authExpireMessage: string
    user: UserDataContract | null

    /** Determine the state of authorization process when app is being INITAILLY loaded. */
    authState: AuthorizationState

    actionCodes: number[]
    showForceLogoutDialog: boolean

    // TODO: this 2 state variables is only used in PasswordManagement Component which should be remove from auth reducer.
    editUserLoading: boolean
    errorUserData: string | null
}
